/* IT Gallery - free-gift promos (Legion Pro 5 + H600, ThinkPad L14 Gen 6 / E16 Gen 3 + headset/mouse/Quick Heal).
   Loaded on every page by snippets/itg-gift-autoadd.liquid (via side-cart-container), which sets window.ITG_PROMO.
   1) Auto-adds every free gift linked to a qualifying laptop when that laptop is in the cart,
      removes them when no qualifying laptop is left, and keeps exactly ONE of each gift line.
      Pairs that share the same gift + tag (the two ThinkPads) share one gift line.
      The Rs 0 price comes from the automatic Buy-X-Get-Y discounts.
   2) Fast path: when a qualifying laptop add request is detected, all of its missing gifts are
      added in one request, then the drawer (side-cart section) is re-rendered in place.
   3) Shows a live you're-saving badge in the cart drawer, read from the real cart discount.
   4) Repositions the promo banners into their correct page slots.
   5) On the /cart page, reloads once after gifts were added/removed so the page never shows stale lines
      (stale lines caused the 'line parameter is invalid' error when removing items).
   API for custom product pages: window.ITG_PROMO_API.reconcile() / .refreshDrawer() (both return promises).
   Set window.ITG_PROMO_HOLD = true while a page adds gifts itself, so this script doesn't double-add. */
(function () {
  if (window.__itgGiftLoaded) return;   /* never run twice on one page */
  window.__itgGiftLoaded = true;
  var P = window.ITG_PROMO || {};
  if (P.active === false) return;

  var GIFT_PROP = '_itg_free_gift';
  var PAIRS = (P.pairs || []).map(function (p) {
    return { buy: String(p.buy || ''), gift: String(p.gift || ''), val: String(p.val || ''), giftInCart: null };
  }).filter(function (p) { return p.buy && p.gift && p.val; });
  var busy = false;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function isCartPage() {
    var p = (location.pathname || '').replace(/\/+$/, '');
    return /(^|\/)cart$/.test(p);
  }

  function postJSON(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addGifts(list) {
    return postJSON('cart/add.js', {
      items: list.map(function (p) {
        var props = {}; props[GIFT_PROP] = p.val;
        return { id: Number(p.gift), quantity: 1, properties: props };
      })
    }).then(function (r) {
      /* if one gift fails (e.g. sold out), add the rest one by one */
      if (r.ok || list.length < 2) return r;
      return list.reduce(function (chain, p) {
        return chain.then(function () { return addGifts([p]); });
      }, Promise.resolve()).then(function () { return r; });
    });
  }
  function setQty(key, qty) { return postJSON('cart/change.js', { id: key, quantity: qty }); }
  /* pairs that share one gift line (same gift variant + tag) */
  function groupOf(p) { return PAIRS.filter(function (q) { return q.gift === p.gift && q.val === p.val; }); }
  function markGroup(p, state) { groupOf(p).forEach(function (q) { q.giftInCart = state; }); }

  /* ---------- live savings badge (cart drawer + cart page) ---------- */
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || 'LKR {{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts[1] === '00' ? parts[0] : parts.join('.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  }
  function isGiftLine(it, p) {
    return String(it.variant_id) === p.gift && it.properties && it.properties[GIFT_PROP] === p.val;
  }
  function giftSavings(cart) {
    var items = cart.items || [];
    var total = 0, count = 0;
    items.forEach(function (it) {
      var match = PAIRS.some(function (p) { return isGiftLine(it, p); });
      if (!match) return;
      var d = it.total_discount || 0;
      if (!d && it.line_level_discount_allocations) {
        it.line_level_discount_allocations.forEach(function (a) { d += a.amount || 0; });
      }
      if (d) { total += d; count += 1; }
    });
    return { total: total, count: count };
  }
  function decorate(cart) {
    var save = giftSavings(cart);
    var targets = [];
    var drawer = document.querySelector('#cart .sticky-in-panel ul.l4tt');
    if (drawer) targets.push(drawer);
    var page = document.querySelector('.template-cart ul.l4tt, #content .l4tt');
    if (page && page !== drawer) targets.push(page);
    targets.forEach(function (ul) {
      var old = ul.parentNode.querySelector('.itg-cart-save');
      if (!save.total) { if (old) old.parentNode.removeChild(old); return; }
      var label = save.count > 1 ? 'Free gifts included' : 'Free gift included';
      var html = '🎁 ' + label + ', you save <b>' + money(save.total) + '</b>';
      if (old) { old.innerHTML = html; return; }
      var el = document.createElement('div');
      el.className = 'itg-cart-save';
      el.innerHTML = html;
      ul.parentNode.insertBefore(el, ul);
    });
  }

  /* Re-render the side-cart drawer from the live cart. */
  function refreshDrawer() {
    var drawer = document.getElementById('cart');
    return fetch(ROOT + '?section_id=side-cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var section = tpl.querySelector('.shopify-section') || tpl.firstElementChild;
        if (!section) return;
        var target = drawer ? (drawer.querySelector('.shopify-section') || drawer) : null;
        if (target) target.innerHTML = section.innerHTML;
        var head = section.querySelector('header[data-totalqty]');
        if (head) {
          var qty = head.getAttribute('data-totalqty');
          document.querySelectorAll('#cart-count').forEach(function (el) { el.textContent = ' ' + qty; });
        }
      })
      .catch(function () {})
      .then(notifyTheme)
      .then(function () { return getCart().then(decorate).catch(function () {}); });
  }

  function notifyTheme() {
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
      try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {}
    });
  }

  /* The /cart page does not re-render by itself when gifts change behind its back, which left stale
     lines on screen (and 'line parameter is invalid' when one was removed). Reload it once. */
  function reloadCartPageIfNeeded() {
    if (!isCartPage()) return;
    var last = 0;
    try { last = parseInt(sessionStorage.getItem('itg_gift_reload') || '0', 10); } catch (e) {}
    if (Date.now() - last < 4000) return;   /* never loop */
    try { sessionStorage.setItem('itg_gift_reload', String(Date.now())); } catch (e) {}
    window.location.reload();
  }

  /* Fast path: a qualifying laptop was just added - add all of its missing gifts at once,
     then run a full reconcile to tidy up anything else. */
  function fastAddGifts(list) {
    if (busy) return;
    busy = true;
    addGifts(list)
      .then(function (r) { if (r && r.ok) list.forEach(function (p) { markGroup(p, true); }); })
      .catch(function () { list.forEach(function (p) { markGroup(p, null); }); })
      .then(function () { busy = false; return reconcile(true); });
  }

  /* Full reconcile: fetch the cart, then add/remove/trim each gift line as needed.
     A gift line is wanted while ANY laptop that shares it is in the cart. */
  function reconcile(forceRefresh) {
    if (busy || !PAIRS.length) return Promise.resolve();
    busy = true;
    var changed = false;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var toAdd = [], ops = [], seen = {};
      PAIRS.forEach(function (p) {
        var gk = p.gift + '|' + p.val;
        if (seen[gk]) return;
        seen[gk] = true;
        var group = groupOf(p);
        var hasBuy = items.some(function (it) {
          return group.some(function (q) { return String(it.variant_id) === q.buy; });
        });
        var lines = items.filter(function (it) { return isGiftLine(it, p); });
        var gift = lines[0] || null;
        markGroup(p, !!gift);
        if (hasBuy && !gift) {
          toAdd.push(p);
        } else if (!hasBuy && gift) {
          lines.forEach(function (l) { ops.push(function () { return setQty(l.key, 0); }); });
          markGroup(p, false);
        } else if (gift) {
          /* keep exactly one free unit tagged as the gift */
          if (gift.quantity > 1) ops.push(function () { return setQty(gift.key, 1); });
          lines.slice(1).forEach(function (l) { ops.push(function () { return setQty(l.key, 0); }); });
        }
      });
      if (toAdd.length) ops.unshift(function () {
        return addGifts(toAdd).then(function () { toAdd.forEach(function (p) { markGroup(p, true); }); });
      });
      if (!ops.length) { decorate(cart); return forceRefresh ? refreshDrawer() : null; }
      changed = true;
      return ops.reduce(function (chain, op) { return chain.then(op); }, Promise.resolve()).then(refreshDrawer);
    }).catch(function () {}).then(function () {
      busy = false;
      if (changed) reloadCartPageIfNeeded();
    });
  }

  window.ITG_PROMO_API = {
    reconcile: function () { return reconcile(false); },
    refreshDrawer: refreshDrawer
  };

  /* Watch cart-changing requests; use the fast path when a qualifying laptop is added. */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  function bodyToString(b) {
    try {
      if (!b) return '';
      if (typeof b === 'string') return b;
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return b.toString();
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        var parts = [];
        b.forEach(function (v, k) { parts.push(k + '=' + v); });
        return parts.join('&');
      }
    } catch (e) {}
    return '';
  }
  function missingPairsForAddBody(bodyStr) {
    if (!bodyStr) return [];
    var list = PAIRS.filter(function (p) { return bodyStr.indexOf(p.buy) !== -1 && p.giftInCart === false; });
    /* one entry per shared gift line */
    var seen = {};
    return list.filter(function (p) { var k = p.gift + '|' + p.val; if (seen[k]) return false; seen[k] = true; return true; });
  }
  function watching(url) { return CART_WRITE.test(url) && !busy && !window.ITG_PROMO_HOLD; }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var watch = watching(url);
      var missing = (watch && CART_ADD.test(url)) ? missingPairsForAddBody(bodyToString(init && init.body)) : [];
      return _fetch.apply(this, arguments).then(function (res) {
        if (watch && res && res.ok) {
          if (missing.length) fastAddGifts(missing);
          else setTimeout(reconcile, 10);
        }
        return res;
      });
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__itgUrl = u; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var url = this.__itgUrl || '';
      if (watching(url)) {
        var missing = CART_ADD.test(url) ? missingPairsForAddBody(bodyToString(body)) : [];
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            if (missing.length) fastAddGifts(missing);
            else setTimeout(reconcile, 10);
          }
        });
      }
      return _send.apply(this, arguments);
    };
  }

  /* Re-apply the savings badge whenever the theme re-renders the drawer itself. */
  ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      if (busy) return;
      setTimeout(function () { getCart().then(decorate).catch(function () {}); }, 150);
    });
  });

  function reveal(el) { if (!el) return; el.removeAttribute('hidden'); el.classList.remove('itg-prepos'); }

  function firstDirectSection(parent) {
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('shopify-section')) return kids[i];
    }
    return null;
  }

  function positionBanners() {
    var content = document.getElementById('content');
    var home = document.querySelector('[data-itg-slot="home"]');
    if (home && content) {
      var hero = firstDirectSection(content);
      if (hero && hero.parentNode) { hero.parentNode.insertBefore(home, hero.nextSibling); }
      else { content.insertBefore(home, content.firstChild); }
      reveal(home);
    }
    var coll = document.querySelector('[data-itg-slot="collection"]');
    if (coll && content) { content.insertBefore(coll, content.firstChild); reveal(coll); }
    var prod = document.querySelector('[data-itg-slot="product"]');
    if (prod) {
      var anchor = document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('.product-form, .product__info, .pf_inner, [data-product-form]');
      if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(prod, anchor); }
      reveal(prod);
    }
  }

  function initStickyVideo() {
    var v = document.getElementById('itg-svid');
    if (!v) return;
    var KEY = 'itg_svid_closed';
    try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}
    v.classList.remove('itg-hide');
    var btn = v.querySelector('.itg-svid__close');
    if (btn) btn.addEventListener('click', function () {
      v.classList.add('itg-hide');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }

  function init() { positionBanners(); reconcile(false); initStickyVideo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
